import { z } from 'zod';

export const CompanySchema = z.object({
  organizationId: z.coerce
    .number({ required_error: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  companyName: z.string().min(1, { message: 'error_field_required' }).max(255, {
    message: `error.field_max_lengh_255`,
  }),
  companyCode: z.string().min(1, { message: 'error_field_required' }).max(255, {
    message: `error.field_max_lengh_255`,
  }),
  nif: z.string().length(9, { message: 'error_field_required_length' }),
  addressLineOne: z
    .string({ required_error: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  addressLineTwo: z.string().max(255, {
    message: `error.field_max_lengh_255`,
  }),
  postCode: z
    .string({ required_error: 'error_field_required' })
    .min(1, { message: 'error_field_required' })
    .max(255, {
      message: `error.field_max_lengh_255`,
    }),
  country: z
    .string({ required_error: 'error_field_required' })
    .min(1, { message: 'error_field_required' })
    .max(255, {
      message: `error.field_max_lengh_255`,
    }),
  city: z
    .string({ required_error: 'error_field_required' })
    .min(1, { message: 'error_field_required' })
    .max(255, {
      message: `error.field_max_lengh_255`,
    }),
  jiraLink: z
    .string()
    .max(255, {
      message: `error.field_max_lengh_255`,
    })
    .optional(),
});

export type FormCompanySchemaType = z.infer<typeof CompanySchema>;

export interface CompanySchemaType extends FormCompanySchemaType {
  id?: number;
  fileId?: number;
  file?: File;
}
